<div class="g-counter-row">
    <div class="g-counter" *ngFor="let counter of counters">
        <p class="g-counter-header">{{counter.header}}</p>
        <p class="g-counter-count">{{counter.count}}</p>
    </div>
</div>